import {
  FormControl as ChakraFormControl,
  FormControlProps as ChakraFormControlProps,
  forwardRef,
} from '@chakra-ui/react';
import {
  ColorMode,
  useColorMode,
} from '@allergan-data-labs/alle-elements-core';

interface FormControlProps extends ChakraFormControlProps {
  isDisabled?: boolean;
  isInvalid?: boolean;
  isRequired?: boolean;
  /** 
    This prop determines which mode the component should display
    @default light
  */
  colorMode?: ColorMode;
}

/**
 * FormControl provides context such as `isInvalid`, `isDisabled`, and `isRequired` to form elements.
 * FormLabel, FormHelperText, and FormErrorMessage provide consistent styling of supporting information.
 * */
export const FormControl = forwardRef<FormControlProps, 'div'>(
  ({ colorMode: propColorMode, ...props }, ref) => {
    const { colorMode } = useColorMode(propColorMode);
    /* The colorScheme value is populated by the colorMode prop. Had to do it
      this way because we cannot extend the chakra-ui component props and
      we kept getting an error for using custom props on a chakra component.
      Keep in mind that not all of our themed library components require
      this method. We also could not use the colorScheme property for our color
      mode changes because certain components, like button, was already using
      the colorScheme property.
    */
    props.colorScheme = colorMode;

    return <ChakraFormControl ref={ref} {...props} />;
  }
);

export { FormLabel, FormErrorMessage, FormHelperText } from '@chakra-ui/react';
